import { Injectable } from '@angular/core';

import { AnalyticsBase } from '../lib/analytics-base';

@Injectable()
export class EventsAnalytics extends AnalyticsBase {
  public readonly namespace = 'Events';
  public readonly requireViewContext = true;

  public trackSchedule() {
    this.track('Schedule', {});
  }

  public trackEventScheduled(props: {
    eventType: string;
    isMoreInterviewers: boolean;
    isEvaluationRequested: boolean;
    isNotifyCandidateEnabled: boolean;
    isNotifyInterviewersEnabled: boolean;
  }) {
    this.track('EventScheduled', props, {
      integrations: { All: false, Mixpanel: true, Intercom: true },
    });
  }
}
